'use strict';

var mediator = require('mediatorjs'),
  _ = require('underscore'),
  $ = require('jquery'),
  ModalView = require('../../js/components/ModalView'),
  config = require('../../js/config'),
  $global = require('../../js/globalElements'),
  session = require('../../js/session/index'),
  utilities = require('../../js/utilities'),

  loginTemplate       = require('../Login/templates/_LoginModal.hbs'),
  mainModalTemplate   = require('./templates/saveto.hbs'),
  loggedInTemplate    = require('./templates/loggedInWrapper.hbs'),
  noResultsTemplate   = require('./templates/projects-noresults.hbs'),
  allProjectsTemplate = require('./templates/projects-results.hbs'),
  createSaveTemplate  = require('./templates/createSaveButtons.hbs'),
  loaderTemplate      = require('../../tmpl/client/loader.hbs'),

  CreateProjectModalView  = require('../DesignCenter/CreateProjectModalView'),
  ProjectsCollection      = require('../DesignCenter/projectsCollection'),
  LinkProjectsCollection  = require('../DesignCenter/LinkProjectsCollection'),

  SaveToModalView = ModalView.extend({

    template: mainModalTemplate,

    events: {
      'click .Modal-createSaveButtons-create': 'openCreateProjectInput',
      'click .Modal-createSaveButtons-save': 'onSaveToProject',
      'change .Modal-allProjects-select': 'onCheckbox'
    },

    initialize: function(options) {
      _.bindAll(this,
        'renderProjects',
        'addCreatedProject',
        'onClickOutsideSubform',
        'close');

      this.options = _.defaults(options, SaveToModalView.__super__.options);
      SaveToModalView.__super__.initialize.apply(this, [options]);

      $global.$body.on('click', '.saveTo', _.bind(this.onSaveToClick, this));
    },

    onSaveToClick: function(e) {
      var $link = $(e.currentTarget),
        uri = $link.data('uri'),
        type = $link.data('type');

      e.preventDefault();
      this.openPopup(uri, type);
    },

    render: function() {
      SaveToModalView.__super__.render.apply(this);
      this.$container = this.$('.Modal-inner');
      this.$container.html(loaderTemplate());
      return this;
    },

    openPopup: function(uri, type) {
      if (!(uri && type)) {
        return; // TODO - what's the requirement if no uri/type?
      }

      this.uri = uri;
      this.type = type;
      this.open();

      if (session.sessionController.isLoggedIn() === false) {
        this.$container.html(loginTemplate({
          loginUrl: utilities.urlTemplate(config.urls.users.login, { url: encodeURIComponent(window.location.href) }),
          registerUrl: utilities.urlTemplate(config.urls.users.register, { url: encodeURIComponent(window.location.href) }),
          logoutUrl: config.urls.users.logout
        }));
      } else {
        this.getProjects();
      }
    },

    getProjects: function() {

      // On new project created
      mediator.on(config.events.designCenter.projectCreatedOnServer, this.addCreatedProject);

      // On sync or sync errors close - TODO on errors render error template
      mediator.on(config.events.designCenter.documentProjectsSynced, this.close);
      mediator.on(config.events.designCenter.productProjectsSynced, this.close);
      mediator.on(config.events.designCenter.documentProjectsSyncFailed, this.close);
      mediator.on(config.events.designCenter.productProjectsSyncFailed, this.close);

      // Received document/product projects
      if (this.type === 'document') {
        mediator.on(config.events.designCenter.projectsFetchedForDocument, this.renderProjects);
        mediator.trigger(config.events.designCenter.fetchProjectsForDocument, this.uri);
      } else if (this.type === 'product') {
        mediator.on(config.events.designCenter.projectsFetchedForProduct, this.renderProjects);
        mediator.trigger(config.events.designCenter.fetchProjectsForProduct, this.uri);
      }
    },

    renderProjects: function(response) {
      this.allProjects = new ProjectsCollection(response.toJSON());
      this.populateAllProjects();
    },

    addCreatedProject: function(model) {
      var modelId = model.get('id');
      model.set('selected', true);
      this.allProjects.add(model);
      this.populateAllProjects(modelId);
    },

    populateAllProjects: function(idToScrollTo) {
      if (session.sessionController.isLoggedIn() === false) {
        this.$container.html(loginTemplate());
      } else {
        this.renderLoggedInTemplate();

        if (this.allProjects.length) {
          this.renderResults(this.allProjects.toJSON());

          if (idToScrollTo) {
            this.scrollToItem(idToScrollTo);
          }
        } else {
          this.renderNoResults();
        }

        this.renderCreateProjectForm();
      }
    },

    scrollToItem: function(idToScrollTo) {
      var $list = this.$projectsContainer.find('.BoxedList'),
        $item = $list.find('#' + idToScrollTo),
        listPosition, listMiddle,
        itemPosition, itemMiddle;

      if ($item) {
        listPosition = $list.scrollTop();
        itemPosition = $item.position().top;
        listMiddle = $list.height() / 2;
        itemMiddle = $item.height() / 2;

        $list.animate({
          scrollTop: listPosition + itemPosition - listMiddle + itemMiddle
        }, 500);
      }
    },

    renderLoggedInTemplate: function() {
      this.$container.html(loggedInTemplate());
      this.$projectsContainer = this.$('#saveto-allProjects');
      this.$saveToForm = this.$('#saveTo-form');
    },

    renderCreateProjectForm: function() {
      this.$createForm = this.$('.Modal-createProject-form');
      this.createProjectView = new CreateProjectModalView({
        el: this.$createForm
      });
      this.createProjectView.render();

      this.$buttons = this.$('.Modal-createSaveButtons');
    },

    renderResults: function(projects) {
      this.$('.Modal-intro').addClass(config.classes.isHidden);
      this.$projectsContainer.html(allProjectsTemplate({allProjects: projects, uri: this.uri}));
      this.$saveToForm.after(createSaveTemplate({results: true}));
    },

    renderNoResults: function() {
      this.$projectsContainer.html(noResultsTemplate());
      this.$saveToForm.after(createSaveTemplate({results: false}));
    },

    onCheckbox: function(e) {
      var $checkbox = $(e.target),
        $checkboxWrapper = $checkbox.parent('.BoxedList-item-wrapper'),
        modelId = $checkbox.attr('id'),
        selected = $checkbox.is(':checked'),
        selectedModel = this.allProjects.findWhere({id: modelId});

      if (selectedModel) {
        selectedModel.set('selected', selected);
      }

      if (selected) {
        $checkboxWrapper.addClass(config.classes.isSelected);
      } else {
        $checkboxWrapper.removeClass(config.classes.isSelected);
      }
    },

    openCreateProjectInput: function() {
      this.$buttons.addClass(config.classes.isHidden);
      this.$createForm.addClass(config.classes.isActive);
      this.$projectsContainer.find('.Modal-allProjects').addClass(config.classes.isHiddenMobile);

      this.$el.on('click', this.onClickOutsideSubform);
    },

    closeCreateProjectInput: function() {
      this.$buttons.removeClass(config.classes.isHidden);
      this.$createForm.removeClass(config.classes.isActive);
      this.$projectsContainer.find('.Modal-allProjects').removeClass(config.classes.isHiddenMobile);

      // Sending event to the CreateProjectModalView to reset the create project form
      this.createProjectView.trigger('createProjectModal:closed');

      this.$el.off('click', this.onClickOutsideSubform);
    },

    onClickOutsideSubform: function(e) {
      e.stopPropagation();
      var $target = $(e.target),
        isCancel = $target.data('remodalAction') === 'cancel',
        isClickedInsideForm = ($target.hasClass('CreateProjectModal-nameInput') ||
                                 $target.hasClass('CreateProjectModal-createButton') ||
                                 $target.hasClass('Modal-createSaveButtons-create'));
      if (isCancel) {
        this.close();
        return;
      }
      if (isClickedInsideForm) {
        return;
      }
      this.closeCreateProjectInput();
    },

    onSaveToProject: function() {
      // Get all 'selected' and 'isInProject' items
      var selectedElements = this.allProjects.filter(function(model) {
          return (model.get('selected') || model.get('containsProduct') || model.get('containsDocument'));
        }),
        linkProjectsCollection = new LinkProjectsCollection(selectedElements);

      // Add state: add to each selected model
      linkProjectsCollection.invoke('set', 'state', 'add');

      // Trigger sync
      if (this.type === 'document') {
        mediator.trigger(config.events.designCenter.syncDocumentProjects, this.uri, linkProjectsCollection);
      } else if (this.type === 'product') {
        mediator.trigger(config.events.designCenter.syncProductProjects, this.uri, linkProjectsCollection);
      }
    },

    onClose: function() {
      this.alreadyFetched = false;
      this.allProjects = null;

      // Sending event to the CreateProjectModalView to reset the create project form
      if (this.createProjectView) this.createProjectView.trigger('createProjectModal:closed');

      this.stopListening();
      mediator.off(config.events.designCenter.projectCreatedOnServer, this.addCreatedProject);
      mediator.off(config.events.designCenter.projectsFetchedForDocument, this.renderProjects);
      mediator.off(config.events.designCenter.projectsFetchedForProduct, this.renderProjects);
      mediator.off(config.events.designCenter.documentProjectsSynced, this.close);
      mediator.off(config.events.designCenter.productProjectsSynced, this.close);
      mediator.off(config.events.designCenter.documentProjectsSyncFailed, this.close);
      mediator.off(config.events.designCenter.productProjectsSyncFailed, this.close);

      if (this.$container) {
        this.$container.html(loaderTemplate());
      }
    }
  });

module.exports = new SaveToModalView();



// WEBPACK FOOTER //
// ./assets/components/SaveTo/SaveToModalView.js